import { useQuerySpecialties } from '@/hooks/query/useQuerySpecialties';
import { useQueryUser } from '@heidi/workspace/data';

const TRAINEE_SPECIALTY_GROUP = 'Trainee';

export function useIsTraineeSpecialty(enabled = true): boolean {
  const { data: specialtyId } = useQueryUser((user) => user.specialty_id);
  const { data: specialties } = useQuerySpecialties((data) => data.specialties, {
    enabled,
  });

  const userSpecialty = specialties?.find((specialty) => specialty.id === specialtyId);

  return userSpecialty?.group?.name === TRAINEE_SPECIALTY_GROUP;
}
